export default "__VITE_ASSET__BFsxrQJT__"